import React, { Component } from 'react';
import {Line} from 'react-chartjs-2';

import '../estaHome.css';
import './interacHora.css';

import Moment from 'moment';

import M from "materialize-css";

import functions from '../../../../functions/Estadisticas/getData';

class Conversa extends Component{

    constructor(){
        super();
        this.state = {
            datosNull: false,
            data:{
                labels: [],
                datasets: [{
                }]
            }
        }
        this.graficaHora();
        
    }

    graficaHora = async (fecha) => {
        const datos = await functions.GetDataGraficoInteraccionesHora(fecha);

        if(datos.dataSet.length > 0){
            await this.setState({
                datosNull: false,
                data:{
                    labels: datos.labels, //en teoria
                    datasets: datos.dataSet
                }
            });
        }else{
            this.setState({datosNull:true});
        }
    }

    capturaFecha = async (e) => {
        let fechaRecibida = Moment(e).format('DD-M-YYYY');
        if(fechaRecibida){
            await this.graficaHora(fechaRecibida);
        }
    }

    componentDidMount(){
        const options = {
            onSelect: this.capturaFecha,
            format:'dd-m-yyyy',
            i18n: {
                months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
                monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"],
                weekdays: ["Domingo","Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
                weekdaysShort: ["Dom","Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
                weekdaysAbbrev: ["D","L", "M", "M", "J", "V", "S"],
                cancel: 'Cancelar',
                done: 'Seleccionar'
            }
        }
        // {onSet: this.capturaFecha}
        const instances = M.Datepicker.init(this.fecha, options);
    }

    render(){
        
        return(
            <div className='col s12 x12'>
                <div className='card-panel empresaCard interacciones'>
                    <p>Intenciones por Hora</p>
                    <div className='row'>
                        <div className='col s6 x3'>
                            <input type='text' className="datepicker" ref={element => this.fecha = element} ></input>
                        </div>
                        <div className='col s6 x3'>
                            <p className='textoInfo'>Seleccione una fecha especifica</p>
                            {/* <button className='teal btn-small' onClick={this.capturaFecha}>Buscar Datos</button> */}
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col s12 x12'>
                        {this.state.datosNull ? <h5 className='center-align'>No hay datos registrados este día</h5> : <Line heigth="5em" data={this.state.data}/> }  
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Conversa;


